import type { FileWithKey } from './types'

// Generate a unique session ID
export const generateSessionId = (): string => {
  return `s_${Date.now()}`
}

// Get content type from file
export const getContentType = (file: File): string => {
  if (file.type) return file.type
  
  const extension = file.name.split('.').pop()?.toLowerCase()
  switch (extension) {
    case 'txt': return 'text/plain'
    case 'html': return 'text/html'
    case 'jpg':
    case 'jpeg': return 'image/jpeg'
    case 'png': return 'image/png'
    case 'pdf': return 'application/pdf'
    case 'mp4': return 'video/mp4'
    case 'json': return 'application/json'
    case 'csv': return 'text/csv'
    case 'xlsx': return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    case 'xls': return 'application/vnd.ms-excel'
    default: return 'application/octet-stream'
  }
}

// Get file type category for icon display
export const getFileType = (file: File): 'pdf' | 'csv' | 'image' | 'xlsx' | 'xls' | 'other' => {
  const extension = file.name.split('.').pop()?.toLowerCase()
  const contentType = file.type.toLowerCase()
  
  if (extension === 'pdf' || contentType.includes('pdf')) return 'pdf'
  if (extension === 'csv' || contentType.includes('csv')) return 'csv'
  if (extension === 'xlsx' || contentType.includes('spreadsheet')) return 'xlsx'
  if (extension === 'xls' || contentType.includes('excel')) return 'xls'
  if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif' || extension === 'webp' || contentType.includes('image')) return 'image'
  
  return 'other'
}

// Get file icon for display
export const getFileIcon = (fileType: 'pdf' | 'csv' | 'image' | 'xlsx' | 'xls' | 'other'): string => {
  switch (fileType) {
    case 'pdf':
      return '📄'
    case 'csv':
      return '📊'
    case 'xlsx':
    case 'xls':
      return '📈'
    case 'image':
      return '🖼️'
    default:
      return '📎'
  }
}

// Get file type label
export const getFileTypeLabel = (fileType: 'pdf' | 'csv' | 'image' | 'xlsx' | 'xls' | 'other'): string => {
  switch (fileType) {
    case 'pdf':
      return 'PDF'
    case 'csv':
      return 'CSV'
    case 'xlsx':
      return 'XLSX'
    case 'xls':
      return 'XLS'
    case 'image':
      return 'Image'
    default:
      return 'File'
  }
}

